import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Check, Facebook, Link2, Loader2, Mail } from "lucide-react";
import { Seo } from "@/components/site/Seo";
import { ArticleView } from "@/components/news/ArticleView";
import { newsApi, photoSrc } from "@/components/news/newsUtils";

const ShareBar = ({ a }) => {
  const [copied, setCopied] = useState(false);
  const url = a.share_url;
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); setCopied(true); } catch { setCopied(false); }
  };
  const btn = "inline-flex items-center gap-2 border border-paper/25 px-3 py-2 text-xs font-semibold text-paper transition-colors hover:border-gold hover:text-gold";
  return (
    <div className="mt-8 flex flex-wrap gap-2" data-testid="article-share-bar">
      <a className={btn} href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer" data-testid="article-share-facebook"><Facebook size={14} aria-hidden="true" /> Share</a>
      <a className={btn} href={`mailto:?subject=${encodeURIComponent(a.title)}&body=${encodeURIComponent(url)}`} data-testid="article-share-email"><Mail size={14} aria-hidden="true" /> Email</a>
      <button type="button" className={btn} onClick={copy} data-testid="article-share-copy">{copied ? <Check size={14} /> : <Link2 size={14} />} {copied ? "Link copied" : "Copy link"}</button>
    </div>
  );
};

export default function NewsArticle() {
  const { slug } = useParams();
  const [a, setA] = useState(null);
  const [state, setState] = useState("loading");
  useEffect(() => {
    setState("loading");
    newsApi.get(`/${encodeURIComponent(slug)}`)
      .then((r) => { setA(r.data ?? null); setState(r.data ? "ready" : "missing"); })
      .catch(() => setState("missing"));
  }, [slug]);

  if (state === "loading") return <section className="min-h-[70svh] bg-navy pt-40"><Loader2 className="container-x animate-spin text-gold" aria-label="Loading" /></section>;
  if (state === "missing" || !a) {
    return (
      <section className="min-h-[70svh] bg-navy pb-24 pt-40 text-paper" data-testid="article-not-found">
        <Seo title="Article Not Found | First Responders Foundation" description="This article is not available." path={`/news/${slug}`} noindex />
        <div className="container-x">
          <h1 className="text-3xl font-extrabold text-paper">This article isn't available.</h1>
          <Link to="/news" className="btn btn-gold mt-8" data-testid="article-back-to-news">See all News & Events</Link>
        </div>
      </section>
    );
  }
  return (
    <>
      <Seo title={`${a.seo_title} | First Responders Foundation`} description={a.seo_description} path={`/news/${a.slug}`} image={photoSrc(a.featured?.url_lg)} />
      <ArticleView a={a} actions={<ShareBar a={a} />} />
      <div className="container-x pb-20">
        <Link to="/news" className="inline-flex items-center gap-2 text-sm font-semibold text-navy hover:text-gold-deep" data-testid="article-all-news-link"><ArrowLeft size={16} aria-hidden="true" /> All News & Events</Link>
      </div>
    </>
  );
}
